import { ColumnState } from "ag-grid-community";
import { create } from "zustand";
import { EQM2010_R01HeaderDto, EQM2010_R01DetailDto, defaultEQM2010_R01HeaderDto, defaultEQM2010_R01DetailDto } from "./Dto_EQM2010_R01";


export interface EQM2010_R01Filter {
    compCd: string;
    workplaceCd: string;
    equipmentType: string;
    equipmentCd: string;
    equipmentNm: string;
    inspectType: string;
    inspectCycle: string;
}

export interface Store_EQM2010_R01 {
    // ====== 필터 관련 ======
    EQM2010_R01Filter: EQM2010_R01Filter;
    EQM2010_R01PastFilter: EQM2010_R01Filter;
    setEQM2010_R01Filter: (filter: Partial<Store_EQM2010_R01['EQM2010_R01Filter']>) => void;
    setEQM2010_R01PastFilter: (filter: Store_EQM2010_R01['EQM2010_R01PastFilter']) => void;

    // ====== 설비점검계획 리스트 및 선택/편집 ======
    EQM2010_R01List: EQM2010_R01HeaderDto[];
    setEQM2010_R01List: (equipmentList: EQM2010_R01HeaderDto[]) => void;

    editEQM2010_R01: EQM2010_R01HeaderDto | null;
    setEditEQM2010_R01: (editEquipment: EQM2010_R01HeaderDto | null) => void;

    selectedEQM2010_R01: EQM2010_R01HeaderDto | undefined;
    setSelectedEQM2010_R01: (data: EQM2010_R01HeaderDto | undefined) => void;
    initSelectedEQM2010_R01: () => void;

    // ====== 상세(디테일) 행 선택/삭제 관리 ======
    deletedEQM2010_R01DetailList: string[];
    setDeletedEQM2010_R01DetailList: (idList: string[]) => void;
    addDeletedEQM2010_R01DetailList: (idList: string[]) => void;
    removeDeletedEQM2010_R01DetailList: (idList?: string[]) => void;

    // ====== 설비점검계획 상세(디테일) 데이터 ======
    EQM2010_R01DetailList: EQM2010_R01DetailDto[];
    setEQM2010_R01DetailList: (data: EQM2010_R01DetailDto[]) => void;
    insertEQM2010_R01DetailList: (data: EQM2010_R01DetailDto[], index?: number) => void;
    removeEQM2010_R01DetailList: (index: number) => void;
    updateEQM2010_R01DetailList: (index: number, data: EQM2010_R01DetailDto) => void;

    // ====== 선택(디테일) 행 선택/삭제 관리 ======
    selectedEQM2010_R01DetailList: string[];
    setSelectedEQM2010_R01DetailList: (idList: string[]) => void;
    addSelectedEQM2010_R01DetailList: (idList: string[]) => void;
    removeSelectedEQM2010_R01DetailList: (idList?: string[]) => void;
    initSelectedEQM2010_R01DetailList: () => void;

    originalEQM2010_R01DetailList: EQM2010_R01DetailDto[];
    setOriginalEQM2010_R01DetailList: (data: EQM2010_R01DetailDto[]) => void;

    // ====== 컬럼 상태(그리드) ======
    columnState: ColumnState[] | null;				setColumnState: (state: ColumnState[] | null) => void;
    detailColumnState: ColumnState[] | null;		setDetailColumnState: (state: ColumnState[] | null) => void;

    scrollTop: number | null;
    setScrollTop: (top: number | null) => void;
    detailScrollTop: number | null;
    setDetailScrollTop: (top: number | null) => void;

    allCount: number;
    setAllCount: (allCount: number) => void;
    detailFetchTrigger: boolean;
    setDetailFetchTrigger: (trigger: boolean) => void;

    // ====== 초기화 ======
    initData: () => void;
}

export const defaultEQM2010_R01Filter: EQM2010_R01Filter = {
    compCd: '',
    workplaceCd: '',
    equipmentType: '',
    equipmentCd: '',
    equipmentNm: '',
    inspectType: '',
    inspectCycle: ''
};

export const useEQM2010_R01Store = create<Store_EQM2010_R01>((set) => ({
    // ====== 필터 관련 ======
    EQM2010_R01Filter: defaultEQM2010_R01Filter,
    EQM2010_R01PastFilter: defaultEQM2010_R01Filter,
    setEQM2010_R01Filter: (update) => set((state) => ({
        EQM2010_R01Filter: {
            ...state.EQM2010_R01Filter,
            ...update
        }
    })),
    setEQM2010_R01PastFilter: (filter: Store_EQM2010_R01['EQM2010_R01PastFilter']) => set((state) => {
        return {
            ...state,
            EQM2010_R01PastFilter: filter
        }
    }),

    // ====== 설비점검계획 리스트 및 선택/편집 ======
    EQM2010_R01List: [],
    setEQM2010_R01List: (equipmentList: EQM2010_R01HeaderDto[]) => set((state) => {
        return {
            ...state,
            EQM2010_R01List: equipmentList
        }
    }),

    editEQM2010_R01: defaultEQM2010_R01HeaderDto,
    setEditEQM2010_R01: (editEquipment: EQM2010_R01HeaderDto | null) => set((state) => {
        return {
            ...state,
            editEQM2010_R01: editEquipment
        }
    }),

    selectedEQM2010_R01: undefined,
    
    setSelectedEQM2010_R01: (data: EQM2010_R01HeaderDto | undefined) => set((state) => {
        let editData = null;
        if (data) {
            editData = { ...data };
        }
        return {
            ...state,
            selectedEQM2010_R01: data,
            editEQM2010_R01: editData,
            selectedEQM2010_R01DetailList: [],
            deletedEQM2010_R01DetailList: [],
            detailFetchTrigger: true,
        };
    }),
    initSelectedEQM2010_R01: () => set({
        selectedEQM2010_R01: undefined,
        editEQM2010_R01: defaultEQM2010_R01HeaderDto,
        EQM2010_R01DetailList: [],
        detailFetchTrigger: false,
    }),

    // ====== 상세(디테일) 행 선택/삭제 관리 ======
    deletedEQM2010_R01DetailList: [],
    setDeletedEQM2010_R01DetailList: (idList: string[]) => set((state) => {
        return {
            ...state,
            deletedEQM2010_R01DetailList: idList
        }
    })
    
    
    ,

    // ====== 설비점검계획 상세(디테일) 데이터 ======
    EQM2010_R01DetailList: [],
    setEQM2010_R01DetailList: (data: EQM2010_R01DetailDto[]) => set((state) => {
        let newList: EQM2010_R01DetailDto[] = [];
        let valueAndOrderIndex = 1;
        data.forEach((item) => {
            newList.push({
                ...defaultEQM2010_R01DetailDto,
                ...item,
                valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
                orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
                orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
            });
            valueAndOrderIndex++;
        });

        return {
            ...state,
            EQM2010_R01DetailList: newList
        };
    }),
    insertEQM2010_R01DetailList: (data: EQM2010_R01DetailDto[], index?: number) => set((state) => {
        const newEQM2010_R01DetailList = [...state.EQM2010_R01DetailList];

        let valueIndex = Math.max(0, ...newEQM2010_R01DetailList.map(item => item.valueIndex || 0)) + 1;
        let targetOrderIndex = index ? index : 1;
        // 같은 orderIndex를 가진 행들 중에서 가장 큰 orderIndexSeq 값을 찾는다.
        const maxOrderIndexSeq = Math.max(0, ...newEQM2010_R01DetailList
            .filter(item => item.orderIndex === targetOrderIndex)
            .map(item => item.orderIndexSeq || 0)
        );
        let targetOrderIndexSeq = maxOrderIndexSeq + 1;
        
        const newData = data.map(item => ({ ...defaultEQM2010_R01DetailDto, ...item, 
            valueIndex: valueIndex++,
            orderIndex: targetOrderIndex,
            orderIndexSeq: targetOrderIndexSeq
        }));
        if (index !== undefined) {
            newEQM2010_R01DetailList.splice(index, 0, ...newData);
        } else {
            newEQM2010_R01DetailList.push(...newData);
        }
        return {
            ...state,
            EQM2010_R01DetailList: newEQM2010_R01DetailList
        }
    }),
    removeEQM2010_R01DetailList: (index: number) => set((state) => {
        const newEQM2010_R01DetailList = [...state.EQM2010_R01DetailList].filter((item) => item.valueIndex !== index);
        return {
            ...state,
            EQM2010_R01DetailList: newEQM2010_R01DetailList
        }
    }),
    updateEQM2010_R01DetailList: (valueIndex: number, data: EQM2010_R01DetailDto) => set((state) => {
        const _EQM2010_R01DetailList = state.EQM2010_R01DetailList.map(item =>
            item.valueIndex === valueIndex ? data : item
        );
        return {
            ...state,
            EQM2010_R01DetailList: _EQM2010_R01DetailList
        }
    }),
	
	
	
    addDeletedEQM2010_R01DetailList: (idList: string[]) => set((state) => {
        const _deletedDetailList = [...state.deletedEQM2010_R01DetailList];

        for(const valueIndex of idList) {
            const targetItem = state.EQM2010_R01DetailList.find(item => item.valueIndex === Number(valueIndex));
            /* 
            const isInserted = targetItem?.inserted;
            const isModified = targetItem?.isModified;
            
            if(!isInserted && !isModified && targetItem?.inspectCd) {
                // ✅ valueIndex 대신 inspectCd를 저장
                _deletedDetailList.push(valueIndex, targetItem.inspectCd);
            */
            // UI 표시를 위해 valueIndex는 항상 추가
            _deletedDetailList.push(valueIndex);
            // 서버 삭제를 위해 inspectCd가 있으면 함께 추가
            if(targetItem?.inspectCd) {
                _deletedDetailList.push(targetItem.inspectCd);
            }
        }
        
        return {
            ...state,
            deletedEQM2010_R01DetailList: _deletedDetailList
        }
    }),
	removeDeletedEQM2010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedEQM2010_R01DetailList: [...state.deletedEQM2010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedEQM2010_R01DetailList: [],
	setSelectedEQM2010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedEQM2010_R01DetailList: idList
		}
	}),
	addSelectedEQM2010_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedEQM2010_R01DetailList = [...state.selectedEQM2010_R01DetailList];
		if(idList.length > 0) {
			_selectedEQM2010_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedEQM2010_R01DetailList: _selectedEQM2010_R01DetailList
		}
	}),
	removeSelectedEQM2010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedEQM2010_R01DetailList: [...state.selectedEQM2010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedEQM2010_R01DetailList: () => set({ selectedEQM2010_R01DetailList: [] }),

	originalEQM2010_R01DetailList: [],
	setOriginalEQM2010_R01DetailList: (data: EQM2010_R01DetailDto[]) => set((state) => {
		let newList: EQM2010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultEQM2010_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalEQM2010_R01DetailList: newList
		}
	}),

    // ====== 컬럼 상태(그리드) ======
    columnState: null,			setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
    detailColumnState: null,	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

    scrollTop: null,
    setScrollTop: (top: number | null) => set({ scrollTop: top }),
    detailScrollTop: null,
    setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

    allCount: 0,
    setAllCount: (allCount: number) => set({ allCount }),
    detailFetchTrigger: false,
    setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

    // ====== 초기화 ======
    initData: () => set((state) => ({
        ...state,
        EQM2010_R01Filter: defaultEQM2010_R01Filter,
        EQM2010_R01PastFilter: defaultEQM2010_R01Filter,
        EQM2010_R01List: [],
        selectedEQM2010_R01: undefined,
        EQM2010_R01DetailList: [],
        deletedEQM2010_R01DetailList: [],
        selectedEQM2010_R01DetailList: [],
        editEQM2010_R01: defaultEQM2010_R01HeaderDto,
        allCount: 0,
        detailFetchTrigger: false,
        scrollTop: null,
        detailScrollTop: null,
    })),

    
}));
